import React from "react";

const LoaderMessage = ({ message }) => {
  return (
    <div className="loader-message">
      <h2>{message}</h2>
    </div>
  );
};

export default LoaderMessage;
